import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=45241ad5"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"
import style0 from "./AllCourses.vue?vue&type=style&index=0&id=45241ad5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports